"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rowKebabMenu = _interopRequireDefault(require("../row-kebab-menu"));

var _dataGridContext = _interopRequireDefault(require("../../../data-grid-context"));

var DoItYourselfView = function DoItYourselfView(_ref) {
  var DoItYourselfComponent = _ref.DoItYourselfComponent,
      rowData = _ref.rowData,
      getKebabMenuOptions = _ref.getKebabMenuOptions,
      gridSize = _ref.gridSize,
      onClickFunc = _ref.onClickFunc,
      getKebabMenuLoader = _ref.getKebabMenuLoader;

  var _useContext = (0, _react.useContext)(_dataGridContext["default"]),
      searchQuery = _useContext.searchQuery,
      showDoItYourselfView = _useContext.showDoItYourselfView;

  var getEditMenu = function getEditMenu(item) {
    if (getKebabMenuLoader) {
      var loader = getKebabMenuLoader(item);

      if (loader) {
        return loader;
      }
    }

    var menuOptions = item && getKebabMenuOptions(item);

    if (!menuOptions) {
      return null;
    }

    var filteredOptions = menuOptions.filter(function (option) {
      return !option.hidden;
    }); // If there are no menu options, don't show kebabmenu

    if (filteredOptions.length === 0) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement(_rowKebabMenu["default"], {
      item: item,
      menuIdentifier: item && item.id,
      options: filteredOptions
    });
  };

  return showDoItYourselfView && /*#__PURE__*/_react["default"].createElement(DoItYourselfComponent, {
    data: rowData,
    searchQuery: searchQuery,
    getKebabMenu: getEditMenu,
    gridSize: gridSize,
    onClickFunc: onClickFunc
  });
};

DoItYourselfView.propTypes = {
  DoItYourselfComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]).isRequired,
  gridSize: _propTypes["default"].shape({
    xs: _propTypes["default"].number,
    sm: _propTypes["default"].number,
    md: _propTypes["default"].number,
    lg: _propTypes["default"].number,
    xl: _propTypes["default"].number
  }),
  getKebabMenuOptions: _propTypes["default"].func.isRequired,
  onClickFunc: _propTypes["default"].func,
  rowData: _propTypes["default"].array.isRequired,
  getKebabMenuLoader: _propTypes["default"].func
};
var _default = DoItYourselfView;
exports["default"] = _default;